import { gql } from '@apollo/client';
const GET_CURRENT_TENANT_SEASONS = gql `
  query GetCurrentTenantSeasons($first: Int = 20, $after: String = "") {
    me {
      id
      currentTenant {
        id
        seasons(first: $first, after: $after) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              name
              workingSeason
              canNameBeUpdated
              canBeRemoved
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_SEASONS;
